import React, { createContext, useContext, useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { RefreshToken } from '../Services/LoginService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    userId: localStorage.getItem('userId'),
    token: localStorage.getItem('token'),
    refreshToken: localStorage.getItem('refreshToken'),
    sessionId: localStorage.getItem('sessionId'),
    fullName: localStorage.getItem('fullName'),
    subscriptionEnd: localStorage.getItem('subscriptionEnd'),
  });

  // Auto-refresh token if near expiration
  useEffect(() => {
    if (!auth.token) return;

    const decoded = jwtDecode(auth.token);
    const expiration = decoded.exp * 1000;
    const now = Date.now();

    const timeLeft = expiration - now;
    const refreshTime = 1000 * 60 * 13.5; // 13.5 minutes

    if (timeLeft < refreshTime) {
      (async () => {
        try {
          const result = await RefreshToken(auth.token, auth.refreshToken, auth.sessionId);
          localStorage.setItem('token', result.token);
          localStorage.setItem('refreshToken', result.refreshToken);
          setAuth(prev => ({ ...prev, token: result.token, refreshToken: result.refreshToken }));
        } catch (err) {
          console.error('Refresh error:', err);
          logout(); // Optional: redirect to login
        }
      })();
    }
  }, [auth.token]);

  const logout = () => {
    localStorage.clear();
    setAuth({});
    window.location.href = '/login'; // or use `navigate()` if in a component
  };

  return (
    <AuthContext.Provider value={{ auth, setAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
